'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchBidderBiddingIfNeeded = exports.LOAD_BIDDER_BIDDING_SUCCESS = exports.LOAD_BIDDER_BIDDING_REQUEST = exports.LOAD_BIDDER_BIDDING_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _api = require('../api');

var _user = require('./user');

var _config = require('./config');

var _loaded = require('./loaded');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_BIDDER_BIDDING_FAIL = exports.LOAD_BIDDER_BIDDING_FAIL = 'la/domain/bidderBidding/LOAD_FAIL';
var LOAD_BIDDER_BIDDING_REQUEST = exports.LOAD_BIDDER_BIDDING_REQUEST = 'la/domain/bidderBidding/LOAD_REQUEST';
var LOAD_BIDDER_BIDDING_SUCCESS = exports.LOAD_BIDDER_BIDDING_SUCCESS = 'la/domain/bidderBidding/LOAD_SUCCESS';

/* ACTION CREATORS */
var fetchIfNeeded = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref2) {
        var dispatch = _ref2.dispatch,
            getState = _ref2.getState;
        var state, authToken, deployment, response;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        state = getState();
                        _context.prev = 1;
                        authToken = (0, _user.getAuthToken)(state);
                        deployment = (0, _config.getDeployment)(state);

                        dispatch({
                            meta: { actionTime: Date.now() },
                            type: LOAD_BIDDER_BIDDING_REQUEST
                        });
                        _context.next = 7;
                        return _api.BiddingInfo.fetchBidderBidding({ authToken: authToken, deployment: deployment });

                    case 7:
                        response = _context.sent;

                        dispatch({
                            meta: { actionTime: Date.now() },
                            payload: response.data,
                            type: LOAD_BIDDER_BIDDING_SUCCESS
                        });
                        _context.next = 14;
                        break;

                    case 11:
                        _context.prev = 11;
                        _context.t0 = _context['catch'](1);

                        dispatch({
                            error: true,
                            meta: { actionTime: Date.now() },
                            payload: _context.t0,
                            type: LOAD_BIDDER_BIDDING_FAIL
                        });

                    case 14:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined, [[1, 11]]);
    }));

    return function fetchIfNeeded(_x) {
        return _ref.apply(this, arguments);
    };
}();

var fetchBidderBiddingIfNeeded = exports.fetchBidderBiddingIfNeeded = function fetchBidderBiddingIfNeeded() {
    return function (dispatch, getState) {
        var state = getState();
        var authToken = (0, _user.getAuthToken)(state);
        if (authToken && (0, _loaded.shouldFetchBiddingInfoForBidder)(state)) {
            return fetchIfNeeded({ dispatch: dispatch, getState: getState });
        }
        return _promise2.default.resolve({});
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/bidderBiddingInfo.js
// module id = fGVB
// module chunks = 60